/**
 * @prettier
 */
import moment from 'moment';
import 'moment/locale/sv';
import 'moment/locale/es';
import { getLanguage } from 'src/i18n/language';

moment.locale(getLanguage());
